import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-basic-pie',
    templateUrl: './basic-pie.component.html',
    styleUrls: ['./basic-pie.component.scss'],
    standalone: false
})
export class BasicPieComponent implements OnChanges {
  get pieTotal() {
    return 2 * Math.PI * 25;
  }

  @Input() amount = 0;
  @Input() total = 0;

  pieValue = 0;

  updatePieValue(amount: number) {
    this.pieValue = (amount / this.total) * this.pieTotal;
  }

  ngOnChanges({ amount }: SimpleChanges) {
    if (amount) {
      this.updatePieValue(amount.currentValue);
    }
  }
}
